export const colorsArray = [
  "#F76E88",
  "#FF8D38",
  "#FFBB33",
  "#A9D844",
  "#47CEAC",
  "#26C7D9",
  "#8888F2",
  "#C88AE8",
];

export const recurrenceActionsOptions = [
  { value: "THIS", label: "common:only_this_occurrence" },
  { value: "THIS_FOLLOWING", label: "common:this_and_future_occurrences" },
  { value: "ALL", label: "all_past_and_future_occurrences" },
];

export const DAILY_VIEW = "DAILY";
export const WEEKLY_VIEW = "WEEKLY";
export const THREE_DAY_VIEW = "THREE_DAY";
export const LANDSCAPE = "LANDSCAPE";
export const PORTRAIT = "PORTRAIT";

export const TIME_AXIS = "TIME_AXIS";

export const WEEKLY_PLANNER_PRINT_PREFERENCE = "WeeklyPlannerPrintPreference";
